import { render } from "./page-land-list.vue?vue&type=template&id=6e43ecb2"
import script from "./page-land-list.vue?vue&type=script&lang=js"
export * from "./page-land-list.vue?vue&type=script&lang=js"
script.render = render

export default script